import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

import { attachActions } from "./actions";
import { IOnlineCourseUpsertStore } from "./interface";
import { OnlineCourseTab, TabStatus } from "@onair/constants";

// course from api

const initialState: IOnlineCourseUpsertStore = {
	action: null,
	course: null,
	activeSection: null,
	activeLesson: null,
	uploads: [],
	preventDraft: false,
	isSaving: false,
	deleteSections: [],
	deleteLessons: [],
	currentLesson: null,
	deleteLessonResources: [],
	changes: {
		course: null,
		section: {},
		lesson: {},
		product: {},
	},
	isDisabledPublish: false,
	lastUpdated: null,
	initCourse: (course) => {},
	publishCourse: () => {},
	updateCourse: (course) => {},
	updateSection: (section) => {},
	updateSections: (sections) => {},
	updateLesson: (lesson) => {},
	setPreventDraft: () => {},
	setIsSaving: () => {},
	updateProduct: (product) => {},
	updateProductFromAPI: (product) => {},
	handleDeleteSection: (section) => {},
	handleDeleteLesson: (lesson) => {},
	handleDeleteLessonResource: ({
		lessonId,
		resourceId,
		isMain,
	}: {
		lessonId: string;
		resourceId: string;
		isMain: boolean;
	}) => {},
	resetChangeCourse: () => {},
	resetChangeSection: () => {},
	resetChangeProduct: () => {},
	resetChangeLesson: () => {},
	resetDeleteLessonResources: (
		ids?: {
			lessonId: string;
			resourceId: string;
			isMain: boolean;
		}[],
	) => {},
	resetForm: () => {},
	setAction: (action) => {},
	setActiveSection: (section) => {},
	setActiveLesson: (lesson) => {},
	setCurrentLesson: (lesson) => {},
	// Tab validation
	mapLessonErrors: {},
	mapSectionErrors: {},
	tabStatuses: {
		[OnlineCourseTab.INFORMATION]: TabStatus.DEFAULT,
		[OnlineCourseTab.CONTENT]: TabStatus.DEFAULT,
		[OnlineCourseTab.PRICING]: TabStatus.DEFAULT,
	},
	tabTriggers: {
		[OnlineCourseTab.INFORMATION]: undefined,
		[OnlineCourseTab.CONTENT]: undefined,
		[OnlineCourseTab.PRICING]: undefined,
	},
	tabStates: {
		[OnlineCourseTab.INFORMATION]: undefined,
		[OnlineCourseTab.CONTENT]: undefined,
		[OnlineCourseTab.PRICING]: undefined,
	},
	registerTabTrigger: (tab, trigger) => {},
	registerTabState: (tab, state) => {},
	updateTabStatus: (tab, status) => {},
	updateLessonErrors: (lessonId, hasError) => {},
	updateSectionErrors: (sectionId, hasError) => {},
};

export const useStoreCourseUpsert = create<IOnlineCourseUpsertStore>(
	subscribeWithSelector((set, get) => ({
		...initialState,
		...attachActions(set, get),
	})),
);
